import naja from 'naja';
import { Form } from './Form';

export default class OrderPerson {
    static init(): void {
        this.initEmailInput();
        this.initSubmitOrder();

        naja.snippetHandler.addEventListener('afterUpdate', (event: { detail: { snippet: { id: string } } }) => {
            if (event.detail.snippet.id === 'snippet-orderPersonForm-emailForms') {
                Form.handleFixedLabel();
                OrderPerson.initEmailInput();
            }
        });
    }

    static initSubmitOrder(): void {
        const submitOrderButtons = document.querySelectorAll('#submitOrder');

        submitOrderButtons.forEach((button) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();

                const personForm = document.querySelector('[data-validation]') as HTMLFormElement;
                if (!personForm) return;

                Form.validateForm(personForm);

                const errors = personForm.querySelectorAll('.form-container--error');
                if (errors.length > 0) {
                    const firstError = errors[0] as HTMLElement;
                    firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    return;
                }

                const hiddenSubmit = personForm.querySelector('[data-form-trigger]') as HTMLButtonElement;
                if (hiddenSubmit) {
                    hiddenSubmit.click();
                }
            });
        });
    }

    static initEmailInput(): void {
        let typingTimer: ReturnType<typeof setTimeout> | null = null;
        const typingInterval = 1200;

        const input = document.getElementById('emailOrderInput') as HTMLInputElement;

        if (input) {
            input.addEventListener('keydown', (e: KeyboardEvent) => {
                if (e.keyCode === 9) {
                    e.preventDefault();
                    const phoneInput = document.getElementById('personContactPhone');
                    if (phoneInput) {
                        phoneInput.focus();
                    }
                    this.doneTypingEmail();
                }
                if (typingTimer) {
                    clearTimeout(typingTimer);
                }
            });

            input.addEventListener('keyup', () => {
                if (typingTimer) {
                    clearTimeout(typingTimer);
                }
                typingTimer = setTimeout(() => this.doneTypingEmail(), typingInterval);
            });

            input.addEventListener('change', () => {
                this.doneTypingEmail();
            });
        }
    }

    static doneTypingEmail(): void {
        const input = document.getElementById('emailOrderInput') as HTMLInputElement;
        const form = document.getElementById('frm-orderPersonForm-emailForm') as HTMLFormElement;

        if (input && input.checkValidity()) {
            naja.uiHandler.submitForm(form);
        }
    }
}
